import { render, staticRenderFns } from "./mailingListTable.vue?vue&type=template&id=119dd5d0"
import script from "./mailingListTable.vue?vue&type=script&lang=js"
export * from "./mailingListTable.vue?vue&type=script&lang=js"
import style0 from "./mailingListTable.vue?vue&type=style&index=0&id=119dd5d0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports